import { createReducer, createSelector } from '@reduxjs/toolkit';
import { getInvitationNotificationsForHearingSuccess } from '../actions/api';
import { updateDtoList } from '../helpers/reducerHelpers';
import {
  getIncludedData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';
import { NOTIFICATIONQUEUE_INCLUDE } from '../../constants/api';
import { API_REDUCER } from '../../constants/store';
import { getEntityId } from '../helpers/apiHelpers';

// -------- Overview --------
// NotificationQueue is included in the following endpoints
//  - GET /hearing/{hearingId}/invitationNotifications

// -------- Reducer --------
const notificationQueueReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder.addCase(
      getInvitationNotificationsForHearingSuccess,
      (state, action) => {
        const data = getIncludedData(action);
        const notificationQueues = data.filter(
          (include) => include.type === NOTIFICATIONQUEUE_INCLUDE,
        );
        return updateDtoList(state, 'all', notificationQueues);
      },
    );
  },
);

// -------- Selectors --------
const selectAllNotificationQueues = (state) =>
  selectAllFromApiState(state, API_REDUCER.NOTIFICATION_QUEUE);

const allNotificationQueuesSelector = createSelector(
  selectAllNotificationQueues,
  (notificationQueues) => notificationQueues,
);

const notificationQueuesByIdsSelector = (notificationQueueIds) =>
  createSelector(allNotificationQueuesSelector, (notificationQueues) =>
    notificationQueues.filter((nq) =>
      notificationQueueIds.some((id) => getEntityId(nq) === id),
    ),
  );

export { notificationQueuesByIdsSelector };
export default notificationQueueReducer;
